import 'immutability-helper';
import '../../../../router/helpers/initRouter.js';
import '../../../../router/routes/dev/model.js';
import '../../../../router/routes/dev/routes.js';
import '../../../../router/routes/dashboard/model.js';
import '../../../../router/routes/pro/model.js';
import '../../../../router/routes/visitsPage/model.js';
import '@caresend/types';
import '../../../../router/routes/orderFlow/model.js';
import '../../../../router/routes/orderFlow/privateHelpers.js';
import '../../../../router/routes/orderFlow/routes.js';
import '../../../../router/routes/schedulingFlow/model.js';
import '../../../../router/routes/schedulingFlow/routes.js';
import { ChartingFlowRouteName } from '../../../../router/routes/chartingFlow/model.js';
import '../../../../router/routes/chartingFlow/routes.js';
import '../../../../router/routes/portal/portalRoutes.js';
import '../../../../router/routes/portal/model.js';
import '../../../../router/routes/visitsPage/routes.js';
import { getStore } from '../../../helpers/initStore.js';

// ROOT STEPS
const getPrintRequisitionFormsTitle = (route) => {
    var _a, _b;
    const store = getStore();
    const { orderID } = route.params;
    const s = Object.values((_b = (_a = store.state.chartingFlow.data[orderID !== null && orderID !== void 0 ? orderID : '']) === null || _a === void 0 ? void 0 : _a.procedures) !== null && _b !== void 0 ? _b : {}).length > 1 ? 's' : '';
    return `Print Requisition Form${s}`;
};
/**
 * If a FlowTitleGetter is defined for a given route, it will be used to
 * determine the title of the page. If not, the title will be determined by
 * the title defined in routes.
 */
const chartingFlowTitleGetters = {
    [ChartingFlowRouteName.PRINT_REQUISITION_FORMS]: getPrintRequisitionFormsTitle,
};

export { chartingFlowTitleGetters };
